import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

// Plugin personalizado para agregar espacio debajo de la leyenda
const legendSpacingPlugin = {
  id: 'legendSpacing',
  beforeInit(chart: any) {
    const originalFit = chart.legend.fit;
    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += 20; // Agregar 20px de espacio debajo de la leyenda
    };
  }
};

@Component({
    selector: 'mh-chart-widget',
    templateUrl: './chart-widget.component.html',
    styleUrls: ['./chart-widget.component.scss'],
    standalone: false
})
export class ChartWidgetComponent implements OnInit {
  @Input() lineChars;
  @Input() isHotel = true;
  @Input() loading: boolean;
  @Input() error: boolean;
  @Output() retryFetch = new EventEmitter();
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  
  // Agregar el plugin a las opciones del gráfico
  public chartPlugins = [legendSpacingPlugin];
  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        align: 'start',
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets.map((dataset, i) => {
              return {
                text: dataset.label,
                fillStyle: dataset.borderColor,
                strokeStyle: dataset.borderColor,
                lineWidth: 2,
                hidden: !chart.isDatasetVisible(i),
                index: i,
                datasetIndex: i,
                pointStyle: 'circle'
              };
            });
          }
        },
        onHover: function (e) {
          if (e?.native?.target?.style) {
            e.native.target.style.cursor = 'pointer';
          }
        },
      },
    },
    hover: {
      onHover: function (e) {
        if (e?.native?.target?.style) {
          e.native.target.style.cursor = 'default';
        }
      },
    },
    scales: {
      y: {
        ticks: {
          padding: 10,
          min: 0,
          max: 100,
        },
      },
      x: {
        ticks: {
          autoSkip: true,
        },
      },
    },
  };

  ngOnInit() {
    // yAxis scale when is no hotel is 0-5
    this.lineChartOptions.scales.y.ticks.max = this.isHotel ? 100 : 5;
  }

  get title() {
    return this.isHotel ? 'iro.trends.title' : 'iro.trends.title-score';
  }
}
